// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import type { OperationOptions } from "@azure-rest/core-client";

/** Optional parameters. */
export interface RestorableDatabaseAccountsListOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface RestorableDatabaseAccountsListByLocationOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface RestorableDatabaseAccountsGetByLocationOptionalParams extends OperationOptions {}
